const hosts = new Set([
  'fashionunited.at',
  'fashionunited.ca',
  'fashionunited.ca/fr',
  'fashionunited.cl',
  'cn.fashionunited.com',
  'fashionunited.co',
  'fashionunited.com.ar',
  'fashionunited.com.br',
  'fashionunited.com.pe',
  'fashionunited.com.tr',
  'fashionunited.cz',
  'fashionunited.dk',
  'fashionunited.fi',
  'fashionunited.hk',
  'fashionunited.hu',
  'fashionunited.jp',
  'fashionunited.lu',
  'fashionunited.no',
  'fashionunited.nz',
  'fashionunited.pl',
  'fashionunited.pt',
  'fashionunited.se',
  'fashionunited.com',
  'fashionunited.it',
  'fashionunited.uk',
  'fashionunited.es',
  'fashionunited.mx',
  'ru.fashionunited.com',
  'fashionunited.ch',
  'fashionunited.fr',
  'fashionunited.be',
  'fashionunited.be/fr',
  'fashionunited.nl',
  'fashionunited.in',
  'fashionunited.ie',
  'fashionunited.de',
  'au.fashionunited.com',
  'bg.fashionunited.com',
  'cy.fashionunited.com',
  'gr.fashionunited.com',
  'ee.fashionunited.com',
  'hr.fashionunited.com',
  'lt.fashionunited.com',
  'lv.fashionunited.com',
  'mt.fashionunited.com',
  'ro.fashionunited.com',
  'sk.fashionunited.com',
  'si.fashionunited.com',
]);

const isJobsComplete = (host) => hosts.has(host);

export default isJobsComplete;
